import i18n from "@/i18n";

const InvoiceDepts = {
    all: i18n.t("project_filter.invoice_setup_BOTH"),
    meg: i18n.t("project_filter.invoice_setup_MEG"),
    projects: i18n.t("project_filter.invoice_setup_PROJECTS")
};

export { InvoiceDepts };
